import React, { } from 'react';
import { useProcessStatusContext } from './context/ProcessStatusContext';
import Modal from '../../../../Components/Modal';
import ModalBody from '../../../../Components/ModalBody';
import ModalFooter from '../../../../Components/ModalFooter';
import Btn from '../../../../Components/Btn';
import { dateUtils } from '../../../../Util/DateUtil';
import { Article } from '../../../../Components/Article/Article';
import { List, ListItem } from '../../../../Components/List';

const { humanizedDurationFromNow } = dateUtils();

const ProcessRequestsDetails = () => {
	const {
		requestDetailsRequested,
		handleCloseRequestDetails,
		processWorkflowState
	} = useProcessStatusContext();

	const requests = processWorkflowState?.mainState.requests?.sort((a, b) => new Date(b.requestDateUtc).getTime() - new Date(a.requestDateUtc).getTime()) ?? [];

	if (requests.length === 0) {
		handleCloseRequestDetails();
		return null;
	}

	return (
		<Modal
			onClose={() => handleCloseRequestDetails()}
			isOpen={requestDetailsRequested}
			width={400}
		>
			<ModalBody>
				<div className="fw_medium s_18">{'Upcoming request'}</div>

				<Article>
					<List removeVerticalMargin={true}>
						<ListItem
							text="Date"
							value={humanizedDurationFromNow(requests[0].requestDateUtc)}
							valueMinWidth={180}
						/>
						<ListItem
							text="Status"
							value={requests[0].requestStatus}
							valueMinWidth={180}
						/>
					</List>
				</Article>
			</ModalBody>
			<ModalFooter
				className='mt_10'
				primaryAction={
					<Btn
						message={'Close'}
						onClick={() => handleCloseRequestDetails()}
					/>
				}
			/>
		</Modal>
	);
};


export default ProcessRequestsDetails;